import { BaseSvgIcon } from './BaseSvgIcon'

export const BreastLeftIcon = (props: any) => {
  const { width = 66, height = 80, ...rest } = props

  return (
    <BaseSvgIcon width={width} height={height} viewBox="0 0 66 80" {...rest}>
      <path
        d="M1.71253 48.2515C0.253882 42.2488 0.414211 36.2346 0.41492 30.1177L0.414653 7.99817C0.410751 5.51772 0.0415901 4.96206 1.96677 2.96281C4.17811 0.666422 7.82734 0.581792 10.211 2.70808C11.5426 3.89594 11.5451 5.32137 11.5884 6.93877C11.6989 9.54029 11.1782 15.0367 12.0872 17.2C13.6902 21.0147 17.9095 21.0733 21.4981 21.7359C33.6228 23.9747 47.2127 28.9272 53.6153 39.6196C54.8967 41.7589 55.9342 44.1538 56.0512 46.6425C56.6746 59.9045 45.4473 71.2287 31.5366 71.6687C17.8987 72.1003 4.13155 60.9022 1.71253 48.2515Z"
        fill="white"
      />
      <path
        d="M1.71253 48.2515C0.253882 42.2488 0.414211 36.2346 0.41492 30.1177L0.414653 7.99817C0.410751 5.51772 0.0415902 4.96206 1.96677 2.96281C4.17811 0.666422 7.82734 0.581792 10.211 2.70808C11.5426 3.89594 11.5451 5.32137 11.5884 6.93877C9.93812 5.43241 9.28084 2.86463 6.45666 2.86135C1.87241 2.85605 2.39561 8.00616 2.39978 10.8626L2.40164 32.1004C2.4027 35.9319 2.31305 39.4535 2.18137 43.2539C2.14776 44.2244 2.45795 47.6778 1.71253 48.2515Z"
        fill="black"
      />
      <path
        d="M63.9568 50.5074C66.1329 50.7236 65.7596 52.0513 65.5805 53.6009C64.2698 64.9697 52.4066 78.1388 39.9506 79.076C37.2496 79.3578 38.3258 77.1175 38.7367 76.988C39.3638 76.7903 40.0994 76.7474 40.7522 76.6473C51.2254 75.0363 59.6187 65.8648 62.4972 56.5571C62.9405 55.1253 63.2092 50.807 63.9568 50.5074Z"
        fill="black"
      />
    </BaseSvgIcon>
  )
}
